import { IApiAxiosError } from "@/api";
import { Alert, AlertTitle } from "@mui/material";

interface IProps {
    /**
     * The error object
     */
    error: Error;
}

/**
 * PreprocessError component
 */
export const PreprocessError = ({ error }: IProps) => {
    const axiosError = error as IApiAxiosError;

    return (
        <Alert severity="error" sx={{ width: "100%" }}>
            <AlertTitle>
                {axiosError.response?.status === 400
                    ? "Invalid file format"
                    : "Error"}
            </AlertTitle>
            {axiosError.response?.data.detail ||
                "An unexpected error occurred."}
        </Alert>
    );
};
